import React from "react";
import { ViewContainerFabric } from "@msidentity/SISU/components/view-container/fabric/view-container-fabric";
import { FlowId, ViewId } from "@msidentity/SISU/constants/routing-constants";
import { useDocumentTitle } from "@msidentity/SISU/hooks";
import { useActivateView } from "@msidentity/SISU/hooks/use-activate-view";
import { commonBindingsFabric } from "@msidentity/SISU/utilities/formatted-text-with-bindings";
import { usernameRecoveryGenericStringsFabric } from "../../../fabric/username-recovery-strings-fabric";
import { useSelectAlias } from "../../../hooks/use-select-alias";
import { type RecoveryAlias } from "../../../username-recovery-types";
import RecoveryAliasList from "./username-recovery-alias-list";
import RecoveryAliasVerificationInput from "./username-recovery-alias-verification-input";

const titleId = "UsernameRecoveryTitle";
const descriptionId = "UsernameRecoveryDescription";

/**
 * Select alias used to sign in for Username Recovery Flow
 * @returns instance of the view
 */
export const UsernameRecoverySelectAliasViewFabric: React.FC =
  function UsernameRecoverySelectAliasViewFabric() {
    const {
      onSubmitHandler,
      onCancelHandler,
      filteredProofState,
      handleAliasSelection,
      handleAliasInputChange,
      selectedAlias,
      aliasInputValue,
      error,
      showAliases,
      usernameRecoveryTitle,
      usernameRecoveryDescription,
      isMultipleAliases,
      radioOptions,
      disablePrimaryButton,
      primaryButtonText,
    } = useSelectAlias();

    useActivateView(ViewId.UsernameRecoverySelectAlias, FlowId.UsernameRecovery, {
      showIdentityBanner: false,
    });
    useDocumentTitle(usernameRecoveryTitle);

    const { strong } = commonBindingsFabric;

    let associatedAccountUx = null;
    if (showAliases) {
      if (isMultipleAliases) {
        associatedAccountUx = (
          <RecoveryAliasList
            radioOptions={radioOptions}
            selectedAlias={selectedAlias}
            handleAliasSelection={handleAliasSelection}
            aliasInputValue={aliasInputValue}
            handleAliasInputChange={handleAliasInputChange}
            error={error}
            isMultipleAliases={isMultipleAliases}
          />
        );
      } else {
        const recoveryAlias: RecoveryAlias = filteredProofState.aliases[0];
        if (!recoveryAlias.isUnmasked) {
          associatedAccountUx = (
            <RecoveryAliasVerificationInput
              selectedRecoveryAlias={recoveryAlias}
              index={0}
              aliasInputValue={aliasInputValue}
              handleAliasInputChange={handleAliasInputChange}
              error={error}
              isMultipleAliases={isMultipleAliases}
            />
          );
        }
      }
    }

    return (
      <ViewContainerFabric
        applyAriaLive
        title={{
          titleId,
          title: usernameRecoveryTitle,
        }}
        primaryButton={{
          label: primaryButtonText,
          buttonId: "iSignin",
          type: "button",
          onClick: onSubmitHandler,
          disabled: disablePrimaryButton,
        }}
        secondaryButton={{
          label: usernameRecoveryGenericStringsFabric.cancel,
          buttonId: "iCancel",
          type: "button",
          onClick: onCancelHandler,
          disabled: false,
        }}
        description={{
          description: usernameRecoveryDescription,
          descriptionId,
          embeddedBindings: { username: strong },
        }}
      >
        {associatedAccountUx}
      </ViewContainerFabric>
    );
  };
